<nav class="navbar">
  <div class="header">
    <p>{{title}}</p>
  </div>
  <ul class="categories">
    <li *ngFor="let link of menu" class="categories_text" [ngClass]="{'active-link': '' == url}">

      <app-element class="elements" [text]="link.title" [isFooter]="'true'" [url]="link.url" [target]="link.url | target">
      </app-element>



    </li>
  </ul>
</nav>
